import { VariablesOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { fetcherShopifyStorefront } from "@repo/graphql-shopify-storefront";
import {
  CustomerAccessTokenCreate_Mutation,
  CustomerCreate_Mutation,
  CustomerRecover_Mutation,
  CustomerReset_Mutation,
  CustomerUpdate_Mutation,
} from "#/graphql/shopify-storefront/mutations";

export async function CustomerRecoverMutationHandler({
  variables,
}: {
  variables: VariablesOfShopifyStorefront<typeof CustomerRecover_Mutation>;
}) {
  const customerRecoverPayload = await fetcherShopifyStorefront(
    CustomerRecover_Mutation,
    variables,
  );

  return customerRecoverPayload;
}

export async function CustomerResetMutationHandler({
  variables,
}: {
  variables: VariablesOfShopifyStorefront<typeof CustomerReset_Mutation>;
}) {
  const customerResetPayload = await fetcherShopifyStorefront(
    CustomerReset_Mutation,
    variables,
  );

  return customerResetPayload;
}

export async function CustomerAccessTokenCreateMutationHandler({
  variables,
}: {
  variables: VariablesOfShopifyStorefront<
    typeof CustomerAccessTokenCreate_Mutation
  >;
}) {
  const customerAccessTokenCreatePayload = await fetcherShopifyStorefront(
    CustomerAccessTokenCreate_Mutation,
    variables,
  );

  return customerAccessTokenCreatePayload;
}

export async function CustomerCreateMutationHandler({
  variables,
}: {
  variables: VariablesOfShopifyStorefront<typeof CustomerCreate_Mutation>;
}) {
  const customerCreatePayload = await fetcherShopifyStorefront(
    CustomerCreate_Mutation,
    variables,
  );

  return customerCreatePayload;
}

export async function CustomerUpdateMutationHandler({
  variables,
}: {
  variables: VariablesOfShopifyStorefront<typeof CustomerUpdate_Mutation>;
}) {
  const updateAccountPayload = await fetcherShopifyStorefront(
    CustomerUpdate_Mutation,
    variables,
  );

  return updateAccountPayload;
}
